export const defaultApiEndpoint = '/api';

const statusCodes = {
  // Successful
  OK: 200, // get, patch (return a JSON object)
  Created: 201, // post (return a JSON object)
  Accepted: 202, // post, delete, path - async
  NoContent: 204, // delete
  PartialContent: 206, // get - async
  // Error
  Unauthorized: 401, // Not authenticated
  Forbidden: 403, // Authenticated, but no permissions
  UnprocessableEntity: 422 // Validation
};

export const successStatusCodes = [
  statusCodes.OK,
  statusCodes.Created,
  statusCodes.Accepted,
  statusCodes.NoContent,
  statusCodes.PartialContent
];

export const httpErrorMessage = {
  default: '操作失败',
  response: '服务器繁忙',
  request: '请求失败',
  unknown: '未知错误'
};
